import { styled } from '@mui/material/styles';
import React from 'react';
import type { ImageProps } from './Image.types';

const PREFIX = 'Image';

const classes = {
  image: `${PREFIX}-image`,
};

const Root = styled('div')<ImageProps>(({ theme, model }) => ({
  [`&.${classes.image}`]: {
    height: model?.height,
    width: '100%',
    position: 'relative',
    background: `url(${model?.image?.url}) no-repeat`,
    backgroundSize: 'contain',
    backgroundPosition: model?.align,
    [theme.breakpoints.down('lg')]: {
      backgroundPosition: 'center',
    },
  },
}));

export const ImageComponent: React.FC<ImageProps> = ({ model }) => {
  return <Root model={model} className={classes.image} />;
};
